import React from 'react';

interface LineIconProps {
    width?: number;
    height?: number;
    className?: string;
    color?: string;
}

const LineIcon: React.FC<LineIconProps> = ({
    width = 15,
    height = 2,
    className,
    color = 'white'
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 15 2"
            fill="none"
            className={className}
        >
            <path
                d="M1 1H13.5"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default LineIcon;
